import { useEffect } from "react";

import { useUser } from "@/providers/auth/useUser";

const SUPPRESSED_EMAILS = ["dev@sunner.com"];

export const useContentsquareIdentifier = () => {
  const { data: user } = useUser();

  useEffect(() => {
    if (!import.meta.env.VITE_CONTENTSQUARE_CLIENT_ID) {
      return;
    }
    if (!user?.email) {
      return;
    }

    window._uxa = window._uxa || [];

    if (SUPPRESSED_EMAILS.includes(user.email)) {
      window._uxa.push(["optout"]);
      return;
    }

    window._uxa.push(["identify", user.email, { hash: true }]);
  }, [user?.email]);
};
